import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import RadioCard from './RadioCard';

const baseStyles = ({ theme }) => css`
  background: ${theme.colors.white};
  border-bottom: 1px solid ${theme.colors.n500};
  width: 100%;
  padding: ${theme.spacings.mega} 0 ${theme.spacings.mega};
  transition: background-color ${theme.transitions.default};
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:last-of-type {
    border-bottom: 0;
  }
`;

const indentStyles = ({ theme, sideIndent }) =>
  sideIndent &&
  css`
    padding-left: ${theme.spacings.kilo};
    padding-right: ${theme.spacings.kilo};
  `;

const Container = styled('li')(baseStyles, indentStyles);

const RadioItem = ({ sideIndent, ...props }) => (
  <Container sideIndent={sideIndent}>
    <RadioCard {...props} />
  </Container>
);

RadioItem.propTypes = {
  itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  text: PropTypes.string,
  isActive: PropTypes.bool,
  sideIndent: PropTypes.bool,
  centered: PropTypes.bool,
};

RadioItem.defaultProps = {};

export default RadioItem;
